module.exports = __webpack_public_path__ + "static/media/G.833b8c39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/G.jpg
// module id = 75
// module chunks = 0